export default "__VITE_ASSET__CBqbAC2u__"